import React, { useState } from 'react';

const LifestyleStep = ({ answers, setAnswers }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  
  const questions = [
    {
      key: 'exercise',
      question: 'آیا ورزش می‌کنید؟',
      options: ['بله، مرتب', 'ورزشکار حرفه‌ای هستم', 'گاهی اوقات', 'خیر']
    },
    {
      key: 'smoking',
      question: 'آیا سیگار می‌کشید؟',
      options: ['بله', 'خیر']
    },
    {
      key: 'stress',
      question: 'سطح استرس شما چقدر است؟',
      options: ['کم', 'متوسط', 'زیاد']
    },
    {
      key: 'sleep',
      question: 'کیفیت خواب شما چگونه است؟',
      options: ['خوب', 'متوسط', 'ضعیف']
    },
    {
      key: 'doctor',
      question: 'آیا متخصص پوست دارید؟',
      options: ['بله', 'خیر']
    },
    {
      key: 'diet',
      question: 'رژیم غذایی شما چگونه است؟',
      options: ['متعادل', 'گیاهخواری', 'کم‌چرب', 'دیگر']
    }
  ];

  const handleSelect = (answer) => {
    const updatedLifestyle = {
      ...answers.lifestyle,
      [questions[currentQuestion].key]: answer
    };
    setAnswers({ ...answers, lifestyle: updatedLifestyle });
    
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    }
  };

  const currentQ = questions[currentQuestion];

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">{currentQ.question}</h2>
      <div className="grid grid-cols-2 gap-4">
        {currentQ.options.map((option) => (
          <button
            key={option}
            onClick={() => handleSelect(option)}
            className={`p-4 rounded-lg border-2 transition-transform duration-200 transform hover:scale-105 focus:outline-none ${
              answers.lifestyle[currentQ.key] === option
                ? 'bg-black text-white border-black'
                : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
            }`}
          >
            <span className="text-sm font-medium">{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LifestyleStep; 